import { SUPPORTED_PLATFORMS } from '../constants/media-platform';
import { isVideoUrlField } from './video-url-utils';

export const validateVideoUrl = (url: string): { isValid: boolean; type: 'mp4' | 'social' | 'invalid' } => {
  if (!url) return { isValid: false, type: 'invalid' };

  try {
    const validUrl = new URL(url);

    // Verificar si es URL de redes sociales
    const isSocialMedia = Object.values(SUPPORTED_PLATFORMS || {}).some(
      platform => platform.match && platform.match(url)
    );

    if (isSocialMedia) {
      return { isValid: true, type: 'social' };
    }

    // Verificar si es MP4
    if (validUrl.pathname.toLowerCase().endsWith('.mp4')) {
      return { isValid: true, type: 'mp4' };
    }

    return { isValid: false, type: 'invalid' };
  } catch {
    return { isValid: false, type: 'invalid' };
  }
};

export const validateRequiredFields = (formData: any, requiredFields: string[]): string[] => {
  return requiredFields.filter(field => {
    const value = formData[field];

    // Para VideoUrl objects
    if (isVideoUrlField(value)) {
      return !value.originalUrl || value.originalUrl.trim() === '';
    }

    // Para strings y otros tipos
    return !value || (typeof value === 'string' && value.trim() === '');
  });
};
